(function() {
	'use strict';

	/**
	 * Service for managing messaging to the user.
	 */

	angular
		.module("pwc.services.message")
		.service("MessageService", MessageService);

	MessageService.$inject = ['$mdToast', '$log', 'lodash'];

	function MessageService($mdToast, $log, lodash){

		/* jshint validthis: true */
		var self = this;

		self.state = {
			toast: null
		};

		self.showToast = showToast;
		self.hideToast = hideToast;
		self.hasToast = hasToast;
		self.showActionToast = showActionToast;

		/**
		 * Begin Methods
		 */

		function showToast(message, hideDelay){

			var hideAfter = hideDelay || 0;

			if (! hasToast()){
				$log.debug('Showing toast message...', message);
				self.state.toast = $mdToast.show($mdToast.simple().position('top right').hideDelay(hideAfter).textContent(message));

				return self.state.toast;
			}

			$log.debug('Updating toast message...', message);

			return updateTextContent(message);
		}

		function showActionToast(message){

			var toast = $mdToast.simple()
				.textContent(message)
				.hideDelay(0)
				.action('OK')
				.highlightAction(false)
				.position('top right');

			return $mdToast.show(toast).then(function(response) {
				if(response == 'ok'){
					$mdToast.hide();
				}
			});
		}

		function hasToast(){
			return lodash.isNotEmptyOrNull(self.state.toast);
		}

		function hideToast(){
			$mdToast.hide(self.state.toast).then(function(){
				self.state.toast = null;
			});
		}

		function updateTextContent(content){
			return $mdToast.updateTextContent(content);
		}
	}

})();
